module.exports = __webpack_public_path__ + "static/media/product7.924f2c96.jpg";